/**
 * i18n 配置常量
 * @module i18n/config
 */

/**
 * 默认语言
 */
export const DEFAULT_LOCALE = 'ja-JP'

/**
 * 回退语言（当翻译缺失时使用）
 */
export const FALLBACK_LOCALE = 'ja-JP'

/**
 * 支持的语言列表
 * Japanese first for Japan customers
 */
export const SUPPORTED_LOCALES = ['ja-JP', 'zh-CN', 'zh-TW', 'en-US', 'fr-FR']

/**
 * 语言选择器选项配置
 * 用于在 UI 中展示语言切换下拉框
 * Japanese first for Japan customers
 */
export const LOCALE_OPTIONS = [
  {
    value: 'ja-JP',
    label: '日本語',
    nativeLabel: '日本語',
    flag: '🇯🇵',
  },
  {
    value: 'zh-CN',
    label: '简体中文',
    nativeLabel: '简体中文',
    flag: '🇨🇳',
  },
  {
    value: 'zh-TW',
    label: '繁體中文',
    nativeLabel: '繁體中文',
    flag: '🇹🇼',
  },
  {
    value: 'en-US',
    label: 'English',
    nativeLabel: 'English',
    flag: '🇺🇸',
  },
  {
    value: 'fr-FR',
    label: 'Français',
    nativeLabel: 'Français',
    flag: '🇫🇷',
  },
]
